module.exports = __webpack_public_path__ + "img/stack_5.f1d1626e.png";